import { render, staticRenderFns } from "./WindowData.vue?vue&type=template&id=a705c324&"
import script from "./WindowData.vue?vue&type=script&lang=js&"
export * from "./WindowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports